export const feeds = [
  {
    id: 1,
    photoUrl:
      "https://images.unsplash.com/photo-1603826254095-65b30e1f3bb7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=600&q=60",
    likes: 10,
    comments: 20,
    user: "Manan Desai",
  },
  {
    id: 2,
    photoUrl:
      "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
    likes: 1542,
    comments: 220,
    user: "DKP",
  },
  {
    id: 3,
    photoUrl:
      "https://images.unsplash.com/photo-1604070477255-d605bd060bb4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
    likes: 15,
    comments: 2,
    user: "UTP",
  },
  {
    id: 4,
    photoUrl:
      "https://images.unsplash.com/photo-1513956860062-4983f30a954d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80",
    likes: 1500,
    comments: 356,
    user: "DP",
  },
  {
    id: 5,
    photoUrl:
      "https://images.unsplash.com/photo-1603826254095-65b30e1f3bb7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=600&q=60",
    likes: 10,
    comments: 20,
    user: "Manan Desai",
  },
  {
    id: 6,
    photoUrl:
      "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
    likes: 1542,
    comments: 220,
    user: "DKP",
  },
  {
    id: 7,
    photoUrl:
      "https://images.unsplash.com/photo-1604070477255-d605bd060bb4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
    likes: 15,
    comments: 2,
    user: "UTP",
  },
  {
    id: 8,
    photoUrl:
      "https://images.unsplash.com/photo-1513956860062-4983f30a954d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80",
    likes: 1500,
    comments: 356,
    user: "DP",
  },
];
